import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../lib/api';

// === FETCH PREVIEW FROM URL ===
export const fetchPreview = createAsyncThunk(
  'urlTrainer/fetchPreview',
  async (
    {
      url,
      skip_patterns,
      exclude_urls,
      max_pages,
      deduplicate,
      remove_low_content,
      min_words,
      keyword_filter,
    },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await api.post('/admin/train-url/preview/', {
        url,
        skip_patterns,
        exclude_urls,
        max_pages,
        deduplicate,
        remove_low_content,
        min_words,
        keyword_filter,
      });
      return data;
    } catch (err) {
      const error =
        err?.response?.data?.detail ||
        err?.response?.data?.error ||
        err?.message ||
        'Preview failed';
      return rejectWithValue(error);
    }
  }
);

// === SAVE TEXT TO TRAINING DATA ===
export const saveUrlText = createAsyncThunk(
  'urlTrainer/saveUrlText',
  async ({ url, text, title }, { rejectWithValue }) => {
    try {
      const { data } = await api.post('/admin/train-url/save/', { url, text, title });
      return data;
    } catch (err) {
      const error = err?.response?.data?.detail || err?.message || 'Saving failed';
      return rejectWithValue(error);
    }
  }
);

const urlTrainerSlice = createSlice({
  name: 'urlTrainer',
  initialState: {
    text: '',
    visited: [],
    loading: false,
    saved: false,
    error: null,
    progress: 0,
    progressLogs: [],
  },
  reducers: {
    resetUrlState: (state) => {
      state.text = '';
      state.visited = [];
      state.loading = false;
      state.saved = false;
      state.progressLogs = [];
      state.error = null;
      state.progress = 0;
    },
    updateProgress: (state, action) => {
      state.progress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreview.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.saved = false;
        state.progress = 5; // Initial loading
      })
      .addCase(fetchPreview.fulfilled, (state, action) => {
        state.loading = false;
        state.text = action.payload.text;
        state.visited = action.payload.visited;
        state.progress = 100;
      })
      .addCase(fetchPreview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to preview URL';
        state.progress = 0;
      })
      .addCase(saveUrlText.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveUrlText.fulfilled, (state) => {
        state.loading = false;
        state.saved = true;
      })
      .addCase(saveUrlText.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to save data';
      });
  },
});

export const { resetUrlState, updateProgress } = urlTrainerSlice.actions;
export default urlTrainerSlice.reducer;
